export default __webpack_public_path__ + "images/Calculator.v-7e7a2d8df7bcd66ab4dae4a47158276b.png";